import { useState } from 'react'
import { useParams } from 'react-router-dom'

import { MyDocumentsFolderListPageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useUnsafeEffect } from 'modules/core/hooks/useEffect'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import DocumentURLContext from 'modules/documents/components/Documents/List/DocumentURLContext'
import FolderType from 'modules/documents/components/FolderType'
import { Folder } from 'modules/documents/hooks/useGetFolders'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const FolderPage = () => {
  const { employee: currentEmployee } = useCurrentSession()
  const { navigation } = useNavigation()
  const { folderId } = useParams()
  const [selectedFolder, setSelectedFolder] = useState<Folder | null>()

  const documentRoutesContext = {
    show: (documentId: string | number) =>
      navigation.documents.folderId.documentId.fullPath({
        folderId: String(folderId),
        document_id: String(documentId),
      }),
  }

  const { loading, data, error } = useQuery(MyDocumentsFolderListPageDocument, {
    variables: {
      employeeId: currentEmployee.id,
      folderId: String(folderId),
    },
  })

  const folderOwner = data?.employees?.employee
  const employeeFolder = folderOwner?.folders.find((f) => f.folderId === String(folderId))
  const folder = data?.documents?.folders[0]

  useUnsafeEffect(() => {
    setSelectedFolder(folder)
  }, [folder])

  const canUploadDocument = (employeeFolder && employeeFolder._policies?.edit.can) ?? false

  const newDocumentUrl = navigation.documents.folderId.new.fullPath({ folderId: String(folderId) })

  const authorized = folder !== null

  return (
    <DocumentURLContext.Provider value={documentRoutesContext}>
      <ResponsivePage.Body
        loading={loading}
        error={error}
        showHeader={false}
        authorized={authorized}
      >
        {folder && (
          <FolderType
            folder={folder}
            employeeId={currentEmployee.id}
            legalEntityCountry={data?.employees?.employee?.legalEntity?.country}
            parentRoute={navigation.documents.folderId.fullPath({ folderId: folder.id })}
            backActionUrl={newDocumentUrl}
            selectedFolder={selectedFolder}
            onFolderSelected={setSelectedFolder}
            canUploadDocument={canUploadDocument}
          />
        )}
      </ResponsivePage.Body>
    </DocumentURLContext.Provider>
  )
}

export default FolderPage
